<form #step3form="ngForm" class="editForm customMat" validate>
    <div class="tab-pane fade in active">
        <div class="flex-center">
            <button fxHide [fxShow.gt-xs]="true" mat-raised-button class="back" (click)="goToPrevious(step3form);$event.preventDefault();">< zurück</button>
            <h4 class="sub">{{title}}</h4>
            <button fxHide [fxShow.gt-xs]="true" mat-raised-button class="next" [disabled]="!testForm.valid" (click)="goToNext(step3form);$event.preventDefault();">weiter ></button>
        </div>
        <div class='row'>
            <div class='col-xs-offset-1 col-xs-10'>
                <div class="row flex-strech">
                    <div class='col-xs-12 col-sm-6'>
                        <div class="item">

                            <div class="flex-space-between">
                                <div>
                                    <img class="box-image" src="assets/images/icon_baujahr.png" />
                                    <p class="sub">Baujahr</p>
                                </div>
                                <div>
                                    
                                    <mat-slider
                                        [disabled]="disabled"
                                        [invert]="invert"
                                        [max]="max"
                                        [min]="min"
                                        [step]="step"
                                        [thumbLabel]="thumbLabel"
                                        [(ngModel)]="step3.constructionyear"
                                        [vertical]="vertical"
                                        name="slider1"
                                        required>
                                    </mat-slider>

                                    <div class="flex-space-around">
                                        <span>1900</span>
                                        <span>2020</span>
                                    </div>
                                </div>
                                <div [formGroup]="testForm">
                                    <mat-form-field class="">
                                        <mat-label>Alternativ eingeben</mat-label>
                                        <input matInput type="text" (keydown)="check($event)" [(ngModel)]="step3.constructionyear" formControlName="constructionyear" maxlength="4" required>
                                    </mat-form-field>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class='col-xs-12 col-sm-6'>
                        <div class="item">

                            <div class="flex-space-between">
                                <div>
                                    <img src="assets/images/icon_zustand.png" class="box-image" />
                                    <p class="sub">Objektzustand</p>
                                </div>
                                <div [formGroup]="testForm">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Bitte wählen</mat-label>
                                        <mat-select [(ngModel)]="step3.constructioncondition" formControlName="constructioncondition" required>
                                            <mat-option>--</mat-option>
                                            <mat-option *ngFor="let condition of options" [value]="condition.value">
                                                {{condition.name}}
                                            </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>    
            </div>
        </div>
        <div class="flex-center">
            <button fxShow [fxHide.gt-xs]="true" mat-raised-button class="back" (click)="goToPrevious(step3form);$event.preventDefault();">< zurück</button>
            <button fxShow [fxHide.gt-xs]="true" mat-raised-button class="next" [disabled]="!testForm.valid" (click)="goToNext(step3form);$event.preventDefault();">weiter ></button>
        </div>
    </div>
  </form>
  <app-footer [progress]="60"></app-footer>